import type { FunnelData } from '../types/funnel';

/**
 * Owner-authorized public offer (Oct 6): 2 movers from $99/h Monday–Friday for simple, prepared moves with suitable access.
 * Weekends: 2 movers $129/h. 2-bedroom with second-floor stairs stays at least $129/h. Never 3 movers at $99.
 * The quote engine keeps the standard rate; the reduced rate is applied only by a server-authorized quote.
 */
export const weekdayOffer = { from: 99, crew: 2 as const };

export function isWeekend(date: string): boolean {
  if (!date) return false;
  // Interpret the calendar date itself (service runs on America/New_York dates), independent of device time zone.
  const [y, m, d] = date.split('-').map(Number);
  const day = new Date(Date.UTC(y, m - 1, d)).getUTCDay();
  return day === 0 || day === 6;
}

/** Shows the "from $99" message only where it could genuinely apply. Eligibility is still confirmed by the team. */
export function offerMayApply(d: FunnelData, crewUsed: number): boolean {
  if (crewUsed !== weekdayOffer.crew) return false;
  if (d.homeType === 'office') return false;
  if (d.packing === 'professional') return false;
  if (!d.bedrooms || !['few', 'studio', '1', '2'].includes(d.bedrooms)) return false;
  const upstairs = (a: FunnelData['origin']) => a.floor !== 'ground';
  if (d.bedrooms === '2' && (upstairs(d.origin) || upstairs(d.destination))) return false;
  if (d.origin.carryBand === 'over_100' || d.destination.carryBand === 'over_100') return false;
  if (d.stops.length > 0) return false;
  return true;
}
